/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Correction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Correction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Transactions/FilterBy/EntityType/Correction"
  
}) {
let tabSelectedLedgerTransactionsFilterByValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.transactions.filter_by',
})
let constantData = 'correction'
let aggregateData = fromAggregate.includes(tabSelectedLedgerTransactionsFilterByValueData, constantData)
let onClick = fromHelpers.useOnFilterClickCorrection({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let transactionsValueData = fromData.useDataValue({ viewPath,
context: 'transactions',
})
let constantData1 = 'correction'
let aggregateData1 = fromHelpers.getCount(transactionsValueData, constantData1)
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 type={aggregateData ? "primary" : "secondary"}
 data="tab.selected.ledger.transactions.filter_by"
 data="'correction'"
 aggregate="/Data/aggregate.js includes"
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Corrections"
/>
<TysiaTag
{...childProps}
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="center"
 type="grey"
 style="filled"
 size="small"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="transactions"
 data="'correction'"
 aggregate="helpers.js getCount"
 text={aggregateData1}
/>
)}
</TysiaTag>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}